import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/components/components.module';
import { WithdrawalPayWithMyBankComponent } from './withdrawal-pay-with-my-bank.component';



@NgModule({
  declarations: [WithdrawalPayWithMyBankComponent],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule
  ],
  exports:[
    WithdrawalPayWithMyBankComponent
  ]
})
export class WithdrawalPayWithMyBankModule { }
